<template>
  <div>
    <div v-if="$auth.policies['view-period-list']" class="pa-4">
      <div class="px-4 mb-6 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="`Chi tiết kỳ đóng ${$options.filters.convertFullDate(detailPeriod.title)}`"
            :link="[
              { text: 'Tài chính', href: '#' },
              { text: 'Kỳ thu/đóng', href: '#' },
              { text: `Chi tiết kỳ đóng ${$options.filters.convertFullDate(detailPeriod.title)}` },
            ]"
          />
        </div>

        <div class="d-flex justify-space-between">
          <v-btn
            v-if="$auth.policies['upload-excel-reconciliation']"
            class="mr-6 pa-5"
            dark
            color="#0D47A1"
            @click="openDialogVerify"
          >
            <v-icon left>mdi-file-download-outline</v-icon>
            Nhập Excel đối soát
          </v-btn>
          <ExportExcel />
          <div v-if="detailPeriod.status === 'finished'">
            <v-btn v-if="$auth.policies['summary-period']" class="search-button ml-6" @click="openDialog" outlined>
              <v-icon>mdi-wallet-plus</v-icon> &nbsp; Tổng kết lại
            </v-btn>
          </div>
        </div>
      </div>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <DetailInfoPeriod />
      </v-card>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <StudentTable />
      </v-card>
      <ReSummary ref="reSummary"></ReSummary>
    </div>
    <div v-else>
      <Page403 />
    </div>
    <PopupVerifyExcel ref="popup-verify" />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import DetailInfoPeriod from '@/modules/tuitionFee/detail-period/DetailInfoPeriod'
import StudentTable from '@/modules/tuitionFee/detail-period/StudentTable'
import { mapActions, mapGetters } from 'vuex'
import ReSummary from '../../modules/tuitionFee/detail-period/ReSummary.vue'
import Page403 from '@/views/Page403.vue'
import ExportExcel from '@/modules/tuitionFee/detail-period/action/ExportExcel.vue'
import PopupVerifyExcel from '../../modules/tuitionFee/detail-period/PopupVerifyExcel.vue'

export default {
  components: {
    Breadcrumbs,
    DetailInfoPeriod,
    StudentTable,
    ReSummary,
    ExportExcel,
    PopupVerifyExcel,
    Page403,
  },
  async created() {
    await this.fetchPeriod(this.$route.params.id)
  },
  computed: {
    ...mapGetters({
      detailPeriod: 'tuitionFeePeriod/detailPeriod',
    }),
  },
  methods: {
    ...mapActions('tuitionFeePeriod', ['fetchPeriod']),
    openDialog() {
      this.$refs.reSummary.openDialog()
    },
    openDialogVerify() {
      this.$refs['popup-verify'].openDialog()
    },
  },
}
</script>
